// Time utility functions for poll management
export const getCurrentTime = (): Date => {
  return new Date()
}

export const isVotingAllowed = (): boolean => {
  const now = new Date()
  const currentHour = now.getHours()
  // Voting allowed until 8 PM (20:00)
  return currentHour < 20
}

export const getTimeUntilDeadline = (): string => {
  const now = new Date()
  const deadline = new Date()
  deadline.setHours(20, 0, 0, 0) // Set to 8 PM today

  if (now > deadline) {
    return "Voting has ended for today"
  }

  const timeDiff = deadline.getTime() - now.getTime()
  const hours = Math.floor(timeDiff / (1000 * 60 * 60))
  const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60))

  return `${hours}h ${minutes}m remaining`
}

export const formatDate = (date: Date): string => {
  return date.toISOString().split("T")[0]
}

export const isToday = (dateString: string): boolean => {
  const today = formatDate(new Date())
  return dateString === today
}

export const isPreviousDay = (dateString: string): boolean => {
  const today = new Date()
  const yesterday = new Date(today)
  yesterday.setDate(yesterday.getDate() - 1)
  return dateString < formatDate(today)
}
